/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable camelcase */
/* eslint-disable react/prop-types */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef, useContext } from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
// import EditIcon from '@material-ui/icons/Edit';
import DescriptionIcon from '@material-ui/icons/Description';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import {
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Grid,
  TextField
} from '@material-ui/core';
import moment from 'moment-timezone';
import Loading from '../../components/loading/Loading';
import FlashContext from '../../components/contexts/FlashContext';
import Button from '../../components/button/MyButton'
import api from '../../service/axios/api';



function createData(
  nosso_numero,
  codigo_barras,
  s3_link,
  created_at,
  nf_nd,
  link,
  order,
  id
) {
  return {
    nosso_numero,
    codigo_barras,
    s3_link,
    created_at,
    nf_nd,
    link,
    order,
    id
  };
}


const useStyles = makeStyles({
  root: {
    width: '100%',
  },
  container: {
    maxHeight: 440,
  },
  table: {
    minWidth: 1100,
  },
});

const StyledTableCell = withStyles(() => ({
  head: {
    // backgroundColor: theme.palette.common.black,
    // color: theme.palette.common.white,
  },
  body: {
    fontSize: 12,
  },
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

// eslint-disable-next-line no-unused-vars
export default function PaymentSlipsTable({
  docs,
  // setDocs,
  page,
  setPage,
  itens,
  setItens,
  total,
  search,
}) {
  const classes = useStyles();
  const [tmp, setTmp] = useState();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState('Enviando arquivo...')
  const { notifySuccess, notifyError } = useContext(FlashContext);
  const [openModal, setOpenModal] = useState(false)
  const [cancelMotivo, setCancelMotivo] = useState()

  const cancelSlip = () => {
    if (cancelMotivo) {
      if (cancelMotivo.trim() !== "") {
        setLoading(true)
        api.paymentSlip.cancelSlip(tmp?.id, cancelMotivo)
          .then(() => {
            setOpenModal(false)
            notifySuccess('Boleto cancelado com sucesso')
            search()
          })
          .catch((err) => notifyError('Erro ao cancelar o boleto'))
          .finally(() => {
            setLoading(false)
          })
      }
      else {
        notifyError('Informe o motivo do cancelamento')
      }
    } else {
      notifyError('Informe o motivo do cancelamento')
    }

  }



  useEffect(() => {
    const list = [];
    docs.forEach(doc => {
      list.push(
        createData(
          doc.nosso_numero,
          doc.codigo_barras,
          doc.s3_link,
          moment.utc(doc.created_at).format('DD/MM/yyyy'),
          doc?.Invoice?.invoice_number || doc?.DebitNote?.nd_number,
          doc?.Invoice?.gcs_pdf || doc?.DebitNote?.gcs_pdf,
          doc?.Invoice?.Order?.order_number || doc?.DebitNote?.Order?.order_number,
          doc.id
        ),
      );
    });
    setRows(list);
  }, [docs]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = event => {
    setItens(+event.target.value);
    setPage(0);
  };



  return (
    <>
      <Loading open={loading} msg={msg} />
      <Paper className={classes.root}>
        <TableContainer component={Paper}>
          <Table className={classes.table} aria-label="customized table">
            <TableHead>
              <TableRow>
                <StyledTableCell>NF/ND</StyledTableCell>
                <StyledTableCell>Pedido</StyledTableCell>
                <StyledTableCell>Nosso Número</StyledTableCell>
                <StyledTableCell>Código de barras</StyledTableCell>
                <StyledTableCell>Boleto</StyledTableCell>
                <StyledTableCell>Data Criação</StyledTableCell>
                <StyledTableCell />
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row, i) => (
                <StyledTableRow key={i}>
                  <StyledTableCell style={{ alignItems: 'center', justifyContent: 'center' }}>
                    <p
                      style={{
                        cursor: 'pointer',
                        color: 'blue',
                      }}
                      className="modal-box-body-value-label"
                      onClick={() => {
                        window.open(row.link)
                      }}
                    >
                      {row.nf_nd}
                    </p>
                  </StyledTableCell>
                  <StyledTableCell>{row.order}</StyledTableCell>
                  <StyledTableCell>{row.nosso_numero}</StyledTableCell>
                  <StyledTableCell>{row.codigo_barras}</StyledTableCell>
                  <StyledTableCell>
                    <DescriptionIcon
                      style={{ cursor: 'pointer' }}
                      onClick={() => {
                        window.open(row.s3_link)
                      }}
                    />
                  </StyledTableCell>
                  <StyledTableCell>{row.created_at}</StyledTableCell>
                  <StyledTableCell>
                    <DeleteForeverIcon
                      style={{ cursor: 'pointer' }}
                      onClick={() => {
                        setTmp(row)
                        setOpenModal(true)
                      }}
                    />
                  </StyledTableCell>

                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[10, 25, 50, 100]}
          component="div"
          // count={rows.length}
          count={total}
          rowsPerPage={itens}
          page={page}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </Paper>
      {/* MODAL DE EDIÇÃO */}
      <Dialog
        onClose={() => setOpenModal(!openModal)}
        open={openModal}
        fullWidth
        maxWidth="sm"
      >
        <Loading open={loading} msg="Cancelando boleto..." />
        <DialogTitle id="simple-dialog-title">Cancelar boleto</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Deseja realmente cancelar o boleto do pedido {tmp?.order}? Está ação não poderá ser desfeita.
          </DialogContentText>
          <Grid item xs={12} style={{ marginTop: '15px' }}>
            <TextField
              className={classes.text}
              variant="outlined"
              size="small"
              fullWidth
              placeholder="Motivo do cancelamento"
              value={cancelMotivo}
              onChange={e => setCancelMotivo(e.target.value)}
              InputProps={{
                classes: {
                  notchedOutline: classes.myTextField,
                  input: classes.text,
                },
              }}
              multiline
              // rowsMax={4}
              rows={4}
            />
          </Grid>
        </DialogContent>

        <DialogActions>
          <h6
            style={{
              cursor: 'pointer',
              color: '#657588',
              fontWeight: 'bold',
              fontFamily: 'Open Sans',
              marginTop: 5,
            }}
            onClick={() => setOpenModal(false)}
          >
            Fechar
          </h6>
          <Button
            style={{ height: 40 }}
            onClick={cancelSlip}
            color="primary"
            variant="contained"
            label='Cancelar'
          />
        </DialogActions>
      </Dialog>
    </>
  );
}
